var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"float-menu",style:({ right: _vm.position + _vm.positionType, cursor: this.event ? 'pointer' : 'default' }),on:{"click":_vm.processClick}},[_vm._v("\n  "+_vm._s(_vm.display)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }